import { Box, Button, FormControl, InputLabel, MenuItem, Select, Skeleton, TextField } from "@mui/material";
import { enqueueSnackbar } from "notistack";
import React, { useMemo, useState } from "react";
import MallScanner from "src/components/shared/ScanningInput";
import useManualCreateBulkReturnProcessing from "src/hooks/orders/bulk-return-processing/useManualCreateBulkReturnProcessing";
import useOrderBatchDetail from "src/hooks/orders/useOrderBatchDetail";
import useOrderByCodeLookup from "src/hooks/orders/useOrderByCodeLookup";

export default function ManualBulkReturnByOrderCode({ warehouseId, returnedFormId }) {
  const [orderCode, setOrderCode] = useState();
  const [manualProductForm, setManualProductForm] = useState({});

  const { data: orders } = useOrderByCodeLookup(orderCode ?? manualProductForm?.orderCode, warehouseId);
  const { data: batches, isLoading: batchLoading } = useOrderBatchDetail(orders?.data?._id, { orderDetail: manualProductForm?.orderDetail });
  const { trigger: manualCreate } = useManualCreateBulkReturnProcessing(returnedFormId);

  const orderDetail = useMemo(() => {
    return orders?.data?.orderDetails?.find((v) => v?._id === manualProductForm?.orderDetail);
  }, [orders?.data?.orderDetails, manualProductForm?.orderDetail]);

  const onCreate = async () => {
    const res = await manualCreate({
      body: manualProductForm,
    });

    if (res?.success) {
      enqueueSnackbar("Thành công!", { variant: "success" });
      setManualProductForm({});
      setOrderCode();
    } else {
      enqueueSnackbar(res?.error?.message, { variant: "error" });
    }
  };

  return (
    <Box>
      <Box
        display="flex"
        gap={1}
        mb={2}
      >
        <TextField
          fullWidth
          label="Mã đơn hàng"
          value={manualProductForm?.orderCode || ""}
          onChange={(e) => setManualProductForm({ ...manualProductForm, orderCode: e.target.value })}
        />
        <MallScanner
          getIndividualValue={setOrderCode}
          individualValue={orderCode}
          variant="outlined"
          label="Scan Mã đơn hàng"
        />
      </Box>
      <Box mb={2}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Sản phẩm</InputLabel>
          <Select
            disabled={!manualProductForm?.orderCode}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={manualProductForm?.orderDetail || ""}
            label="Sản phẩm"
            onChange={(e) => setManualProductForm({ ...manualProductForm, orderDetail: e.target.value })}
          >
            {Array.isArray ? (
              orders?.data?.orderDetails?.map((v) => {
                return (
                  <MenuItem
                    value={v?._id}
                    key={v?._id}
                  >
                    {v?.productModel?.product?.name} - {v?.productModel?.name}
                  </MenuItem>
                );
              })
            ) : (
              <MenuItem value={null}>Không có dữ liệu</MenuItem>
            )}
          </Select>
        </FormControl>
      </Box>

      <Box mb={2}>
        {batchLoading ? (
          <Skeleton width="100%" />
        ) : (
          <FormControl fullWidth>
            <InputLabel id="demo-simple-select-label">Lô sản phẩm</InputLabel>
            <Select
              disabled={!manualProductForm?.orderDetail}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={manualProductForm?.batch || ""}
              label="Lô sản phẩm"
              onChange={(e) => setManualProductForm({ ...manualProductForm, batch: e.target.value })}
            >
              {Array.isArray(batches?.data) ? (
                batches?.data?.map((v) => {
                  return (
                    <MenuItem
                      value={v?.batch?._id}
                      key={v?.batch?._id}
                    >
                      {v?.batch?.code ?? ""}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem value={null}>Không có dữ liệu</MenuItem>
              )}
            </Select>
          </FormControl>
        )}
      </Box>

      <TextField
        disabled={!orderDetail?.qty || !manualProductForm?.batch}
        type="number"
        sx={{ mb: 2 }}
        inputProps={{
          min: 0,
          max: orderDetail?.qty ?? 0,
        }}
        value={manualProductForm?.qty || ""}
        error={manualProductForm?.qty > orderDetail?.qty}
        helperText={manualProductForm?.qty > orderDetail?.qty ? "Vượt quá số lượng" : ""}
        fullWidth
        label="Số lượng"
        onChange={(e) => setManualProductForm({ ...manualProductForm, qty: Number(e.target.value) })}
      />
      <Button
        onClick={onCreate}
        disabled={manualProductForm?.qty > orderDetail?.qty || !orderDetail?.qty || !manualProductForm?.batch}
        variant="contained"
        fullWidth
      >
        Thêm sản phẩm
      </Button>
    </Box>
  );
}
